import { createContext } from '@chakra-ui/react-utils';
import type { SystemStyleObject } from '@chakra-ui/system';

import type { ActionPreviewPart } from './types';

export type ActionPreviewStyles = Partial<
  Record<ActionPreviewPart, SystemStyleObject>
>;

const [ActionPreviewStylesProvider, useActionPreviewStyles] =
  createContext<ActionPreviewStyles>({
    name: 'ActionPreviewStylesContext',
    strict: true,
    errorMessage:
      'useActionPreviewStyles: `context` is undefined. Seems you forgot to wrap all action preview components within `<ActionPreview />`',
  });

export { ActionPreviewStylesProvider, useActionPreviewStyles };
